/**
 * DpAnalysisModelService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DpAnalysisModelService {
    getDropDownOptions = () => {
        return apiClient.get("/getmodel");
    }

    getAnalysisModelsData = (body) => {
        return apiClient.post("/getmodel", body);
    }

    createAnalysisModel = (body) => {
        return apiClient.post("/model", body);
    }

    editAnalysisModel = (body) => {
        return apiClient.post("/editmodel", body);
    }

    deleteAnalysisModel = (id) => {
        return apiClient.post("/deletemodel", { id });
    }

    getToolsDropDownOptions = () => {
        return apiClient.get("/getAllTools");
    }

    getAllMetricsDropDownOptions = () => {
        return apiClient.get("/getAllMetrics");
    }

    getMeasureDropDownOptions = (body) => {
        return apiClient.post("/getMeasuresByTool", body);
    }

    getCategoryDropDownOptions = (body) => {
        return apiClient.post("/getCategoryByMeasure", body);
    }

    getMetricDropDownOptions = (body) => {
        return apiClient.post("/getMetricByCategory", body);
    }

    getRangesNamesDropDownOptions = (body) => {
        return apiClient.post("/getRatiosNamesByMetric", body);
    }
}
